import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PileDetailService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  PileDetailCreateDto,
  PileDetailDto,
  PileDetailExcelDownloadDto,
  PileDetailUpdateDto,
} from '../proxy/planning/dtos/pile-detail';
import { PILEDETAIL_CONFIG, PILEDETAIL_FIELDS } from './pile-detail.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-pile-detail',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, PileDetailService, ConfirmationService],
  templateUrl: './pile-detail.html',
  styleUrl: './pile-detail.scss',
})
export class PileDetail extends BaseHierarchicalCrudComponent<
  PileDetailDto,
  PileDetailCreateDto,
  PileDetailUpdateDto,
  PileDetailExcelDownloadDto
> {
  service = inject(PileDetailService);
  config = PILEDETAIL_CONFIG;
  fields = PILEDETAIL_FIELDS;

  protected prepareUpdateDto(data: any, selected: PileDetailDto): PileDetailUpdateDto {
    return {
      ...data,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'PileDetail';
  }
}
